<section>
    <h2>Investigation List</h2>
    <div class="content-wrapper">
        <app-investigations-table-new [config]="tableConfig"></app-investigations-table-new>
    </div>
</section>